// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Ur-8","bigColWidth":"Table_bigColWidth__3o7Jx","biggerColWidth":"Table_biggerColWidth__2Kjp7","row":"Table_row__3ILqI","col":"Table_col__2PMgT"};